import { render } from "./AutoResponses.vue?vue&type=template&id=31d25650&scoped=true"
import script from "./AutoResponses.vue?vue&type=script&lang=ts"
export * from "./AutoResponses.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-31d25650"

export default script
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QTable,QTr,QTh,QTd,QBtn,QSpace});
